import { isPromoAvailableDate } from '../../../helpers/dateTime';
import { bonusRestrictedGroups, someGroupMember } from '../../../helpers/user';
import { User } from '@/api/auth';

export const EASTER_PROMO_DATE_START = '2025-04-09 00:00:00';
export const EASTER_PROMO_DATE_END = '2025-04-29 23:59:59';

export const isEasterPromoAvailableDate = isPromoAvailableDate(
  EASTER_PROMO_DATE_START,
  EASTER_PROMO_DATE_END
);

export const checkIsEasterPromoAvailable = (user?: User) =>
  !someGroupMember(bonusRestrictedGroups)(user) && isEasterPromoAvailableDate;

export enum MissionStatusGroups {
  Daily = 'DAILYMISSION',
  Qualified = 'QUALIFIED',
  Special = 'USEDEASTERFS',
}

export enum MissionMode {
  PastFailed,
  PastCompleted,
  TodayFailed,
  TodayActive,
  TodayCompleted,
  Future,
}

interface DetermineMissionModeParams {
  isAuthenticated: boolean;
  isWin: boolean;
  isToday: boolean;
  isFuture: boolean;
  missionStarted: boolean;
}

export function determineMissionMode({
  isAuthenticated,
  isWin,
  isToday,
  isFuture,
  missionStarted,
}: DetermineMissionModeParams): MissionMode {
  if (!isAuthenticated) {
    return MissionMode.Future;
  }

  if (isWin) {
    if (isToday) {
      return MissionMode.TodayCompleted;
    }
    return MissionMode.PastCompleted;
  }

  if (isFuture) {
    return MissionMode.Future;
  }

  if (isToday) {
    if (missionStarted) {
      return MissionMode.TodayActive;
    }
    return MissionMode.TodayFailed;
  }

  return MissionMode.PastFailed;
}
